import IGetSiteDiaryResponseModel from "interfaces/Response/IGetSiteDiaryResponseModel";
import AuthorisedVisitorsTemporaryWorkersProps from "interfaces/SiteDiary/AuthorisedTemporaryWorkers/AuthorisedVisitorsTemporaryWorkersProps";

function mapGetSiteDiaryResponseModelToAuthorisedVisitorsTemporaryWorkers(
  siteDiaryResponseModel: IGetSiteDiaryResponseModel,
  diarySaved: boolean,
  diaryDate: string,
  hwrcSiteId: string
): AuthorisedVisitorsTemporaryWorkersProps {
  const authorisedVisitorsTemporaryWorkersProps: AuthorisedVisitorsTemporaryWorkersProps = {
    authorisedVisitorsTemporaryWorkersDetails: [],
    diarySaved,
    diaryDate,
    hwrcSiteId
  };

  if (
    siteDiaryResponseModel.siteDiary
    && siteDiaryResponseModel.siteDiary.authorisedVisitors
  ) {
    authorisedVisitorsTemporaryWorkersProps.authorisedVisitorsTemporaryWorkersDetails = siteDiaryResponseModel.siteDiary.authorisedVisitors.map(entry => (
      {
        hwrcSiteId,
        diaryDate,
        id: entry.id,
        name: entry.name,
        organisation: entry.organisation,
        inducted: entry.inducted,
        timeIn: new Date(entry.timeIn),
        timeOut: entry.timeOut ? new Date(entry.timeOut!) : undefined
      }
    ));
  }

  return authorisedVisitorsTemporaryWorkersProps;
}

export { mapGetSiteDiaryResponseModelToAuthorisedVisitorsTemporaryWorkers };
